import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/gcse", label: "GCSE Maths" },
  { to: "/about", label: "Our Approach" },
  { to: "/blog", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const dashHref = user?.role === "parent" ? "/parent" : "/student";

  return (
    <header className="glass sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <div className="px-2.5 py-1.5 rounded-md bg-brand-navy flex items-center">
            <img src="/brand/logo.png" alt="Genius Education" data-testid="brand-logo" className="h-8 w-auto object-contain" style={{maxWidth: 140}}/>
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="font-serif text-base font-semibold brand-navy">Genius Education</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Est. Wokingham · UK</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map(n => (
            <Link key={n.to} to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={`text-sm font-medium transition-colors ${loc.pathname===n.to ? 'brand-navy' : 'text-slate-600 hover:brand-navy'}`}>
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to={dashHref} className="btn-navy px-4 py-2 rounded-md text-sm" data-testid="nav-dashboard">
                {user.role === "parent" ? "Parent Portal" : "Student Portal"}
              </Link>
              <button onClick={logout} className="text-sm text-slate-600 hover:brand-navy" data-testid="nav-logout">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium brand-navy hover:gold-text" data-testid="nav-login">Login</Link>
              <Link to="/signup" className="btn-gold px-5 py-2.5 rounded-md text-sm" data-testid="nav-signup">Book free trial</Link>
            </>
          )}
        </div>

        <button onClick={() => setOpen(!open)} className="md:hidden brand-navy" data-testid="nav-mobile-toggle">
          {open ? <X size={22}/> : <Menu size={22}/>}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map(n => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="text-slate-700 hover:brand-navy py-1 text-sm">{n.label}</Link>
            ))}
            {user ? (
              <>
                <Link to={dashHref} onClick={() => setOpen(false)} className="btn-navy px-4 py-2 rounded-md text-sm text-center">Portal</Link>
                <button onClick={()=>{logout(); setOpen(false);}} className="text-sm text-slate-600 text-left">Sign out</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={()=>setOpen(false)} className="text-sm brand-navy py-1">Login</Link>
                <Link to="/signup" onClick={()=>setOpen(false)} className="btn-gold px-4 py-2 rounded-md text-sm text-center">Book free trial</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
